import { createSlice } from "@reduxjs/toolkit"

const getInitialThemeMode = () => {
    try {
        const saved = localStorage.getItem("themeMode");
        if (saved === "light" || saved === "dark") return saved;
        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
    } catch (e) {}
    return "light";
};

const getInitialNavCollapsed = () => {
    try {
        return localStorage.getItem("navCollapsed") === "true";
    } catch (e) {}
    return false;
};

const uiSlice = createSlice({
    name: "ui",
    initialState: {
        navDrawer: false,
        navCollapsed: getInitialNavCollapsed(),
        newComment: false,
        timeTracking: false,
        adminMode: false,
        theme: {
            mode: getInitialThemeMode()
        }
    },
    reducers: {
        toggleNavDrawer(state) {
            const { navDrawer } = state;
            return { ...state, navDrawer: !navDrawer }
        },
        toggleNavCollapsed(state) {
            state.navCollapsed = !state.navCollapsed;
        },
        setNavCollapsed(state, action) {
            state.navCollapsed = action.payload;
        },
        openNewComment(state) {
            return { ...state, newComment: true }
        },
        closeNewComment(state) {
            return { ...state, newComment: false }
        },
        toggleTimeTracking(state) {
            const { timeTracking } = state;
            return { ...state, timeTracking: !timeTracking }
        },
        setTimeTracking: (state, action) => {
            state.timeTracking = action.payload;
        },
        toggleTheme: (state) => {
            state.theme.mode = state.theme.mode === 'light' ? 'dark' : 'light';
        },
        setTheme: (state, action) => {
            state.theme.mode = action.payload;
        },
        toggleAdminMode(state) {
            return { ...state, adminMode: !state.adminMode }
        },
        setAdminMode(state, action) {
            return { ...state, adminMode: action.payload }
        },
    },
});

export const { toggleNavDrawer, toggleNavCollapsed, setNavCollapsed, openNewComment, closeNewComment, toggleTheme, setTheme, toggleTimeTracking, setTimeTracking, toggleAdminMode, setAdminMode } = uiSlice.actions;
export default uiSlice.reducer;